module.exports = __webpack_public_path__ + "img/game_item_img4.7af53610.png";